module.exports = __webpack_public_path__ + "img/roxar-corrlog.0d18ec69.png";